import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const iso8601 = /^\d{4}-\d\d-\d\d(T\d\d:\d\d:\d\d(\.\d{1,3})?Z?(\+\d\d:\d\d)?)?$/;

export const dateInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (isIso8601(event.body)) {
          return event.clone({ body: new Date(event.body) });
        } else {
          convertToDate(event.body);
        }
      }
      return event;
    })
  );
};

function convertToDate(body: any): any {
  if (body === null || body === undefined) {
    return body;
  }

  if (Array.isArray(body)) {
    return body.forEach(data => convertToDate(data));
  }

  if (typeof body !== 'object') {
    return body;
  }

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIso8601(value)) {
      body[key] = new Date(value);
    } else if (typeof value === 'object') {
      convertToDate(value);
    }
  }
}

function isIso8601(value: any) {
  if (value === null || value === undefined) {
    return false;
  }

  return iso8601.test(value);
}
